<template>
      <b-form @submit.prevent="onSubmit" v-if="show">
      <check-in-screen :title="$t('termsAndCoditions.title')" :step="4" :loading="isLoading">
                <div class="row">
                  <div class="col-md-12">
                    <b-card no-body class="text-center">
                        <div class="p-2 terms-content">
                            <span v-html="settings.termsConditions"></span>
                        </div>
                        <b-form-group
                          class="col-12 mt-3"
                          style="z-index: 1;"
                          :description="submitStatus === 'ERROR' ? 'Ingresar datos requeridos':''">
                          <b-form-checkbox
                            id="checkbox-1"
                            v-model.trim="$v.status.$model"
                            name="checkbox-1"
                            value="accepted"
                            @change="$v.status.$touch()"
                            unchecked-value="not_accepted"
                            :class="{'is-valid':$v.status.$dirty && !$v.status.$invalid}"
                          >
                            {{$t('termsAndCoditions.isAccepted')}}
                          </b-form-checkbox>
                        </b-form-group>
                    </b-card>
                  </div>
                </div>
        <template #footer>
          <check-in-footer-middle step="resume" :nextValue="$t('footer.next')"  :submitStatus="submitStatus"/>
        </template>
      </check-in-screen>
      </b-form>
</template>

<script>
import CheckInScreen from '@/components/layout/CheckInScreen'
import CheckInFooterMiddle from '@/components/footer/CheckInFooterMiddle'

import { mapState } from 'vuex'

export default {
  name: 'step-four',
  components: {
    CheckInScreen,
    CheckInFooterMiddle
  },
  props: {},
  computed: {
      ...mapState(['settings'])
  },
  data() {
    return {
      show: true,
      status: false,
      submitStatus: null,
      isLoading: false
    }
  },
  validations: {
    status: {
      checked (val) {
        localStorage.removeItem('termsandconditions');
        localStorage.setItem("termsandconditions", val);
        return val
      }
    }
  },
  methods: {
    onSubmit() {
      this.isLoading = true
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
        this.isLoading = false
      } else {
        // do your submit logic here
        this.submitStatus = 'PENDING'
        setTimeout(() => {
          this.submitStatus = 'OK'
          this.isLoading = false
          this.$router.push('resume')
        }, 500)
      }
    },
  },
  created(){
    if(localStorage.getItem("termsandconditions") === 'accepted'){
      this.status = 'accepted'
    }
  },
  mounted(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.terms-content {
  max-height: 45vh;
  overflow-y: auto;
  text-align: left;
  line-height: 1.5;
  border: 1px solid #dee2e6;
  border-radius: var(--brand-radius-sm, 0.375rem);
  background: #fff;
}
</style>
